module.exports = __webpack_public_path__ + "img/main_logo.bc626bf0.png";